module.exports = __webpack_public_path__ + "img/litecoin-sign.606976cd.svg";